import styles from './BalanceChip.module.css';

interface BalanceChipProps {
    amount: string;
}

export function BalanceChip({ amount }: BalanceChipProps) {
    const formatted = parseFloat(amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return (
        <span className={styles.chip}>
            ${formatted}
        </span>
    );
}
